// actions.js
import {
  FETCH_GROUPS_REQUEST,
  FETCH_GROUPS_SUCCESS,
  FETCH_GROUPS_FAILURE,
  DELETE_GROUPS_REQUEST,
  DELETE_GROUPS_FAILURE,
  DELETE_GROUPS_SUCCESS,
  FETCH_GROUP_REQUEST,
  FETCH_GROUP_SUCCESS,
  FETCH_GROUP_FAILURE,
  UPDATE_GROUPS_REQUEST,
  UPDATE_GROUPS_SUCCESS,
  UPDATE_GROUPS_FAILURE,
  OPEN_EDIT_GROUP_PAGE_SUCCESS,
  OPEN_EDIT_GROUP_PAGE,
  KPI_GROUPS_REQUEST,
  KPI_GROUPS_SUCCESS,
  KPI_GROUPS_FAILURE,
  CLEAR_GROUP_ERRORS,
  CLEAR_GROUP_SUCCESS
} from './actionTypes';

export const fetchGroupsRequest = () => ({
  type: FETCH_GROUPS_REQUEST,
});

export const fetchGroupsSuccess = (groups) => ({
  type: FETCH_GROUPS_SUCCESS,
  payload: groups,
});

export const fetchGroupsFailure = (error) => ({
  type: FETCH_GROUPS_FAILURE,
  payload: error,
});

export const fetchGroupRequest = (id) => ({
  type: FETCH_GROUP_REQUEST,
  payload: id
});

export const fetchGroupSuccess = (group) => ({
  type: FETCH_GROUP_SUCCESS,
  payload: group,
});

export const fetchGroupFailure = (error) => ({
  type: FETCH_GROUP_FAILURE,
  payload: error,
});

export const updateGroupRequest = (group, navigate) => ({
  type: UPDATE_GROUPS_REQUEST,
  payload: { group, navigate }
});

export const updateGroupSuccess = () => ({
  type: UPDATE_GROUPS_SUCCESS,
});

export const updateGroupFailure = (error) => ({
  type: UPDATE_GROUPS_FAILURE,
  payload: error,
});

export const deleteGroupRequest = (id) => ({
  type: DELETE_GROUPS_REQUEST,
  payload: id
});

export const deleteGroupSuccess = (id) => ({
  type: DELETE_GROUPS_SUCCESS,
  payload: id,
});

export const deleteGroupFailure = (error) => ({
  type: DELETE_GROUPS_FAILURE,
  payload: error,
});

export const openEditGroupPage = (id, navigate) => ({
  type: OPEN_EDIT_GROUP_PAGE,
  payload: { id, navigate }
});

export const openEditGroupPageSuccess = () => ({
  type: OPEN_EDIT_GROUP_PAGE_SUCCESS,
});

export const fetchGroupsKpiRequest = () => ({
  type: KPI_GROUPS_REQUEST,
});

export const fetchGroupsKpiSuccess = (groupsKpi) => ({
  type: KPI_GROUPS_SUCCESS,
  payload: groupsKpi,
});

export const fetchGroupsKpiFailure = (error) => ({
  type: KPI_GROUPS_FAILURE,
  payload: error,
});

export const clearGroupErrors = () => ({
  type: CLEAR_GROUP_ERRORS,
});

export const clearGroupSuccess = () => ({
  type: CLEAR_GROUP_SUCCESS,
});